import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const Box = styled.div`
  //width: 100%;
  button {
    min-width: 60px;
    border: none;
    text-align: center;
    border-radius: 4px;
    transition: 0.2s;
    padding: 8px 16px 10px 16px;
    cursor: ${props => props.loading ? 'not-allowed' : 'pointer'};
    font-weight: inherit;
    ${props => {
      switch (props.btn) {
        case "primary":
          return `
                background-color: ${Variables.colors.primary_vivid};
                color:${Variables.colors.complementary};
                &:hover{
                    box-shadow: 0 2px 8px 0 #CCCCCC;
                }
                &:disabled{
                    background-color: ${Variables.colors.complementary_400};
                    color:${Variables.colors.complementary_600};
                    cursor:not-allowed;
                    &:hover{
                        box-shadow: none;
                    }
                }
                `;
        case "secondary":
          return `
                background-color: ${Variables.colors.complementary};
                border:solid 1px ${Variables.colors.primary_vivid};
                color:${Variables.colors.primary_vivid};
                padding-bottom: 8px !important;
                &:hover{
                    box-shadow: 0 2px 8px 0 #CCCCCC;
                    background-color: ${Variables.colors.primary_vivid};
                    color:${Variables.colors.complementary};
                }
                &:disabled{
                    background-color: ${Variables.colors.complementary};
                    border:solid 1px ${Variables.colors.complementary_400};
                    color:${Variables.colors.complementary_600};
                    cursor:not-allowed;
                    &:hover{
                        box-shadow: none;
                    }
                }
                `;
        case "outline":
          return `
                background-color: ${Variables.colors.complementary};
                border:solid 1px ${
                  props.borderless
                    ? Variables.colors.complementary
                    : Variables.colors.complementary_400
                };
                color:${Variables.colors.primary_vivid};
                &:hover{
                    background-color: ${Variables.colors.primary_50};
                    border:solid 1px ${Variables.colors.complementary_400};
                }
                &:disabled{
                    border:solid 1px ${Variables.colors.complementary_400};
                    color:${Variables.colors.complementary_500};
                    cursor:not-allowed;
                    &:hover{
                        background-color: ${Variables.colors.complementary};
                    }
                }
                `;
        case "ghost":
          return `
                color:${Variables.colors.complementary_700};
                background-color: transparent;
                &:hover{
                    background-color: ${Variables.colors.primary_50};
                    color:${Variables.colors.primary_vivid};
                }
                &:disabled{
                    color:${Variables.colors.complementary_500};
                    cursor:not-allowed;
                    &:hover{
                        background-color: ${Variables.colors.complementary};
                    }
                }
                `;
        case "little":
          return`
            padding: 7px 16px;
            background-color: ${Variables.colors.complementary};
            color:${Variables.colors.complementary_600};
            border:solid 1px ${Variables.colors.complementary_300};
              // color:${Variables.colors.primary_vivid};
              &:hover{
                  background-color: ${Variables.colors.complementary_250};
                  border:solid 1px ${Variables.colors.complementary_250};
                  color:${Variables.colors.complementary_900};
              }
            ${props.active?
              ` 
                background-color: ${Variables.colors.complementary_250};
                border:solid 1px ${Variables.colors.complementary_250};
                color:${Variables.colors.complementary_900};
              `
              :
              ``
            }
            
          `;
        default:
          return null;
      }
    }};
    position: relative;
`;
export const Loading = styled.div`
  visibility: ${props => props.show ? 'visible' : 'hidden'};
  position: absolute;
  right: calc(50% - 9px);
  top: calc(50% - 9px);
`;
export const Children = styled.div`
  visibility: ${props => props.show ? 'visible' : 'hidden'};
`;